import { ref } from "vue";

import constructFetchError from "./constructFetchError";

import axios from 'axios';

export function useEmployees() {
    const employees = ref(null);
    const totalRecords = ref(null);
    const employee = ref(null);

    const getEmployees = async (params) => {
        try {
            const getEmployeesResponse = await axios.get(route('api.employees.index', params));
            employees.value = getEmployeesResponse.data.data;
            totalRecords.value = getEmployeesResponse.data.meta?.total ?? employees.value.length;
        } catch(e) {
            console.log(e);
            throw constructFetchError(e, 'Error while fetching employees.');
        }
    };

    const getEmployee = async (empid, params) => {
        try {
            const getEmployeeResponse = await axios.get(route('api.employees.show', {
                employee: empid,
                ...params,
            }));
            employee.value = getEmployeeResponse.data.data;
        } catch(e) {
            console.log(e);
            throw constructFetchError(e, 'Error while fetching employee.');
        }
    };

    const getEmployeesEligibleForCommission = async (startTimePeriod, endTimePeriod, location) => {
        try {
            const getEmployeesEligibleForCommissionResponse = await axios.get(route('api.employees.eligible-for-commission.index', {
                START_TIME_PERIOD: startTimePeriod,
                END_TIME_PERIOD: endTimePeriod,
                LOCATION: location
            }));
            employees.value = getEmployeesEligibleForCommissionResponse.data.data;
        } catch(e) {
            console.log(e);
            throw constructFetchError(e, 'Error while fetching employees.');
        }
    };

    const getEmployeesWithHoursWithoutPayslipOnTimePeriod = async (timePeriod, department) => {
        try {
            const getEmployeesResponse = await axios.get(route('api.time-periods.employees-with-hours-without-payslip.index', {
                TIME_PERIOD: timePeriod,
                DEPT: department,
            }));
            employees.value = getEmployeesResponse.data.data;
        } catch(e) {
            console.log(e);
            throw constructFetchError(e, 'Error while fetching employees.');
        }
    };

    const getEmployeesWithDaysOfWorkAndYearsOfService = async (paytype, departmentGroupId, startDate, endDate, params) => {
        try {
            const getEmployeesWithDaysOfWorkAndYearsOfServiceResponse = await axios.get(route('api.employees.days-of-work-and-years-of-service-report.index', {
                paytype: paytype,
                department_group_id: departmentGroupId,
                dow_start_date: startDate,
                dow_end_date: endDate,
                ...params
            }));
            employees.value = getEmployeesWithDaysOfWorkAndYearsOfServiceResponse.data.data;
            totalRecords.value = getEmployeesWithDaysOfWorkAndYearsOfServiceResponse.data.meta?.total;
        } catch(e) {
            console.log(e);
            throw constructFetchError(e, 'Error while fetching employees.');
        }
    };
    
    return {
        employees,
        totalRecords,
        getEmployees,
        getEmployeesEligibleForCommission,
        employee,
        getEmployee,
        getEmployeesWithHoursWithoutPayslipOnTimePeriod,
        getEmployeesWithDaysOfWorkAndYearsOfService,
    };
}
